import { ClearAllSpotlightsDebugSection } from './ClearAllSpotlightsDebugSection'
import { registerStableDebugPanelSection } from './debugRegistry'

registerStableDebugPanelSection({
  id: 'clear-all-spotlights',
  title: 'Spotlights',
  order: 40,
  Component: ClearAllSpotlightsDebugSection,
})
